import React, { Component } from "react";
import Table from 'antd/lib/table';
const columns = [
    {
        title: '学年',
        dataIndex: 'year',
    },
    {
        title: '类型',
        dataIndex: 'type',
    },
    {
        title: '费用',
        dataIndex: 'fee',
    },
    {
        title: '状态',
        dataIndex: 'status'
    }
];
const data = [];
// for (let i = 0; i < 10; i++) {
//     data.push({
//         key: i,
//         year: `2018`,
//         type: '学费',
//         fee: 1000.00,
//         status: '已缴清'
//     });
// }

class Expenses extends Component {
    render() {
        return (
            <div className="personal-grade">
                <div className="personal-grade-content">
                    <div className="title">缴费查询</div>
                    <div className="table">
                        <Table columns={columns} dataSource={data} bordered={true} pagination={{
                            // total: 20,
                            // onChange: (page) => { console.log(page) },
                            style: {
                                float: "left"
                            },
                            className: "gafa-pagination"
                        }} />
                    </div>
                </div>
            </div>
        )
    }
}

export default Expenses